import { doc, onSnapshot, Timestamp } from 'firebase/firestore';
import { AppThunk } from '../../../index';
import { getUserDetailsFailed, getUserDetailsStarted, getUserDetailsSuccess } from '../reducer';
import { UserDocument } from '../../../../models/documents';
import { logOutUser } from './logOutUser';
import { COLLECTION } from '../../../../firestore';

export const getUserDetails =
  (uid: string): AppThunk =>
    async (dispatch, getState, { db, firestoreSubscriptions, analytics, auth }) => {
      // Skip if we're already listening to this uid
      if (
        firestoreSubscriptions.userDetailsListener &&
        firestoreSubscriptions.currentUserDetailsUid === uid
      ) {
        return;
      }

      dispatch(getUserDetailsStarted());
      try {
        const ref = doc(db, COLLECTION.USERS, uid);

        if (firestoreSubscriptions.userDetailsListener) {
          firestoreSubscriptions.userDetailsListener();
        }

        // Store the uid we're listening to
        firestoreSubscriptions.currentUserDetailsUid = uid;

        const idTokenResult = await auth().currentUser?.getIdTokenResult();
        const isImpersonated = idTokenResult?.claims?.impersonated || false;

        firestoreSubscriptions.userDetailsListener = onSnapshot(
          ref,
          (snapshot) => {
            const data = snapshot.data() as
              | (Omit<UserDocument, 'createdAt' | 'updatedAt' | 'lastVerificationEmailSentAt'> & {
                createdAt: Timestamp;
                updatedAt: Timestamp;
                lastVerificationEmailSentAt?: Timestamp | null;
              })
              | undefined;
            dispatch(
              getUserDetailsSuccess(
                data
                  ? {
                    ...data,
                    createdAt: data.createdAt?.toDate(),
                    updatedAt: data.updatedAt?.toDate(),
                    lastVerificationEmailSentAt: data.lastVerificationEmailSentAt?.toDate() || null,
                    systemRole: (idTokenResult?.claims?.systemRole as 'admin' | null) || null,
                    isImpersonated: isImpersonated as boolean,
                  }
                  : undefined
              )
            );
            if (data) {
              analytics.updateUserProperties(uid, {
                email: data?.email,
                name: data.firstName ? `${data.firstName} ${data.lastName ?? ''}` : undefined,
              });
            }
          },
          () => {
            dispatch(getUserDetailsFailed());
            dispatch(logOutUser());
          }
        );
      } catch (_e) {
        dispatch(getUserDetailsFailed());
      }
    };
